import styled from 'styled-components';

import { breakPoint } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import backgroundProblem from '~/static/images/st/back-speed-guest.jpg';
import background from '~/static/images/st/back-speed-page.jpg';

export const ClientPage = styled.div`
    width: 100%;
    justify-content: space-between;
`;

export const Widget = styled.section`
    background: #15233d url(${background}) no-repeat;
    background-size: 100%;
    width: 100%;
    justify-content: center;
    padding: 0 20px;
    display: flex;
`;

export const WidgetContent = styled.div`
    width: 100%;
    max-width: 985px;
    flex-direction: column;
`;

export const TitleH1 = styled.h1`
    ${FONTS.H1};
    color: ${COLORS.TextWhite};
    margin-top: 150px;
    
    @media(${breakPoint(320)}) {
        ${FONTS.H2};
    }
`;

export const WidgetWrap = styled.div`
    background: ${COLORS.BgMain};
    width: 100%;
    padding: 40px 75px;
    
    @media(${breakPoint(320)}) {
        padding: 30px; 
    }    
`;

export const FrameTitle = styled.h2`
    ${FONTS.H2};
    margin-top: 40px; 
    
    @media(${breakPoint(320)}) {
        ${FONTS.H3};
    }
`;

export const FrameDescription = styled.p`
    ${FONTS.S};
    margin-top: 20px;
    
    @media(${breakPoint(320)}) {
        ${FONTS.XS};
    }
`;

export const FAQ = styled.div`
    color: ${COLORS.TextWhite};
    margin-top: 40px;
    margin-bottom: 100px;
    flex-direction: column;
    padding-right: 50px;
    grid-gap: 30px;
`;

export const FAQTitle = styled.h3`
    ${FONTS.H4}
`;

export const FAQContent = styled.ul`
    flex-direction: column;
    grid-gap: 30px;
    display: flex;
`;

export const Problem = styled.section`
    width: 100%;
    min-height: 100vh;
    justify-content: center;
    padding: 0 20px 40px 20px;
    background: url(${backgroundProblem}) no-repeat;
    background-size: cover;
    color: ${COLORS.BgMain};
    margin-bottom: -50px;
    display: flex;
`;

export const ProblemContent = styled.div`
    width: 100%;
    max-width: 985px;
    flex-direction: column;
    margin-top: 100px;
    align-content: flex-start;
    align-items: flex-start;
`;

export const ProblemTitle = styled.h2`
    ${FONTS.H1}
`;

export const ProblemList = styled.ul`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const ProblemUndef = styled.div`
    flex-direction: column;
    width: 100%;
`;

export const ProblemUndefTitle = styled.h2`
    margin-top: 60px;
    ${FONTS.H2}
`;
export const ProblemUndefDescription = styled.p`
    margin-top: 60px;
    ${FONTS.XS}
    > a {
        color: ${COLORS.LabelsBg_5};
        border-bottom: 1px dotted ${COLORS.LabelsBg_5};
        ${FONTS.M}
    }
`;

export const Action = styled(BaseButton)`
    margin-top: 40px;
`;
